

// api
export const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:3000"
export const API_TIMEOUT = 30000
export const API_DEFAULT_HEADER = { "Content-Type": "application/json" }


// storage
export const TOKEN_KEY = 'vldl_token'
export const USER_KEY = 'vldl_user'
export const TENANT_KEY = 'vldl_tenant'


// APP INFO

export const MAIL_TO = "mailto:support@vldl.com"
